import * as React from 'react';
import {ButtonProps, ListItemButton, ListItemButtonProps} from '@mui/material'
import {useMatch, useMatches, matchPath} from "react-router-dom";
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import {
    Link as RouterLink,
    LinkProps as RouterLinkProps,
} from 'react-router-dom';
import {ExpandLess as ExpandLessIcon} from "@mui/icons-material";

interface ListItemLinkProps extends ListItemButtonProps {
    icon?: React.ReactElement;
    primary?: string;
    to?: string;
    target?: string;
}

const Link = React.forwardRef<
    HTMLAnchorElement,
    RouterLinkProps
    //Omit<RouterLinkProps, 'to'> & { href: RouterLinkProps['to'] }
>(function Link(
    itemProps,
    ref,
) {
    return <RouterLink ref={ref} {...itemProps} data-matched={'link-element'} role={undefined} />;
});

function ListItemLink(props: ListItemLinkProps & ButtonProps) {
    const { icon, primary, to, selected } = props;

    return (
        <li>
            {!!to ? (
                <ListItemButton component={Link} to={to} target={props?.target} sx={props?.sx || undefined} selected={selected}>
                    {props.children ? props.children : (
                        <>
                            {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
                            <ListItemText primary={primary} />
                        </>
                    )}
                </ListItemButton>
            ) : (
                <ListItemButton {...props} />
            )}
        </li>
    );
}

export default ListItemLink;